import React from 'react'
import PropTypes from 'prop-types'
import css from './styles.css'

const Middle = ({ isCancelled, scheduledFor }) =>  (
  <div className={css.main}>
    {isCancelled ?
    <h3 className={css.isCancelled}>CANCELLED</h3> :
    [<h3 key='h'>SCHEDULED</h3>, <span key='s'>{scheduledFor}</span>]
    }
  </div>
)

Middle.propTypes = {
  isCancelled: PropTypes.bool.isRequired,
  scheduledFor: PropTypes.string.isRequired,
}

export default Middle



// WEBPACK FOOTER //
// ./src/components/Messages/Blasts/SelectedBlast/Middle.js